module.exports = __webpack_public_path__ + "img/580d93d.png";